// The user's own position offered as a route endpoint, alongside the NearestSearchOptions.
// Like those it is not a real location: `value` is a sentinel held in form state, and the actual
// coordinates are read from indoor positioning at the moment the route is requested.
//
// Unlike the nearest searches it is only offered inside a native shell that ships the positioning
// SDK - older shells wrap this same web app but cannot answer, so they must not be offered it -
// and it shows before the user types anything - reaching for directions from where you are
// standing is the common case, not something you should have to search for.
export const CURRENT_LOCATION_VALUE = 'current_location';

const CurrentLocationOption = {
	label: 'Current Location',
	value: CURRENT_LOCATION_VALUE,
	// Matched against what the user types; kept broad so the obvious synonyms find it.
	search_key: 'Current Location, My Location, Here, Where I am'
};

export const isCurrentLocationOption = value => value === CURRENT_LOCATION_VALUE;

export default CurrentLocationOption;
